



















































































import { defineComponent, ref, computed, watch } from '~/utils/nuxt3-migration'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SLOW } from '~/constants/debounce'
import { Facet } from '~/models/search/types'

export default defineComponent({
  props: facetHandlerComponentProps,
  setup() {
    const { getters } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)
    const { changeParam, changeParams } = useClassifiedSearchFacet()

    const tireWidthFacet = computed(() =>
      getters('getFacetByName')('tire_width')
    )

    const tireRatioFacet = computed(() =>
      getters('getFacetByName')('tire_ratio')
    )

    const tireDiameterFacet = computed(() =>
      getters('getFacetByName')('tire_diameter')
    )

    const tireWidthFrom = ref(
      tireWidthFacet.value?.values?.selected?.low || null
    )
    const tireWidthTo = ref(tireWidthFacet.value.values?.selected?.high || null)
    const tireRatioFrom = ref(
      tireRatioFacet.value?.values?.selected?.low || null
    )
    const tireRatioTo = ref(tireRatioFacet.value.values?.selected?.high || null)
    const tireDiameterFrom = ref(
      tireDiameterFacet.value?.values?.selected?.low || null
    )
    const tireDiameterTo = ref(
      tireDiameterFacet.value.values?.selected?.high || null
    )

    watch(tireWidthFacet, (newFacet: Facet) => {
      tireWidthFrom.value = newFacet?.values?.selected?.low || null
      tireWidthTo.value = newFacet?.values?.selected?.high || null
    })

    watch(tireRatioFacet, (newFacet: Facet) => {
      tireRatioFrom.value = newFacet?.values?.selected?.low || null
      tireRatioTo.value = newFacet?.values?.selected?.high || null
    })

    watch(tireDiameterFacet, (newFacet: Facet) => {
      tireDiameterFrom.value = newFacet?.values?.selected?.low || null
      tireDiameterTo.value = newFacet?.values?.selected?.high || null
    })

    const onTireWidthFromInput = debounce((value: string) => {
      changeParam({
        name: `${tireWidthFacet.value.urlArgNames[0]}-from`,
        value
      })
    }, DEBOUNCE_SLOW)

    const onTireWidthToInput = debounce((value: string) => {
      changeParam({
        name: `${tireWidthFacet.value.urlArgNames[0]}-to`,
        value
      })
    }, DEBOUNCE_SLOW)

    const onTireRatioFromInput = debounce((value: string) => {
      changeParam({
        name: `${tireRatioFacet.value.urlArgNames[0]}-from`,
        value
      })
    }, DEBOUNCE_SLOW)

    const onTireRatioToInput = debounce((value: string) => {
      changeParam({
        name: `${tireRatioFacet.value.urlArgNames[0]}-to`,
        value
      })
    }, DEBOUNCE_SLOW)

    const onTireDiameterFromInput = debounce((value: string) => {
      changeParam({
        name: `${tireDiameterFacet.value.urlArgNames[0]}-from`,
        value
      })
    }, DEBOUNCE_SLOW)

    const onTireDiameterToInput = debounce((value: string) => {
      changeParam({
        name: `${tireDiameterFacet.value.urlArgNames[0]}-to`,
        value
      })
    }, DEBOUNCE_SLOW)

    function onTireWidthClear() {
      tireWidthFrom.value = null
      tireWidthTo.value = null

      changeParams([
        {
          name: `${tireWidthFacet.value.urlArgNames[0]}-from`,
          value: null
        },
        {
          name: `${tireWidthFacet.value.urlArgNames[0]}-to`,
          value: null
        }
      ])
    }

    function onTireRatioClear() {
      tireRatioFrom.value = null
      tireRatioTo.value = null

      changeParams([
        {
          name: `${tireRatioFacet.value.urlArgNames[0]}-from`,
          value: null
        },
        {
          name: `${tireRatioFacet.value.urlArgNames[0]}-to`,
          value: null
        }
      ])
    }

    function onTireDiameterClear() {
      tireDiameterFrom.value = null
      tireDiameterTo.value = null

      changeParams([
        {
          name: `${tireDiameterFacet.value.urlArgNames[0]}-from`,
          value: null
        },
        {
          name: `${tireDiameterFacet.value.urlArgNames[0]}-to`,
          value: null
        }
      ])
    }

    return {
      tireWidthFacet,
      tireRatioFacet,
      tireDiameterFacet,
      tireWidthFrom,
      tireWidthTo,
      tireRatioFrom,
      tireRatioTo,
      tireDiameterFrom,
      tireDiameterTo,
      onTireWidthFromInput,
      onTireWidthToInput,
      onTireRatioFromInput,
      onTireRatioToInput,
      onTireDiameterFromInput,
      onTireDiameterToInput,
      onTireWidthClear,
      onTireRatioClear,
      onTireDiameterClear
    }
  }
})
